import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-salesforce',
    standalone: true,
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './salesforce.component.html',
})
export class SalesforceComponent {}
